module.exports = __webpack_public_path__ + "static/img/h5-4.efcbd27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd101/h5-4.png
// module id = /Doe
// module chunks = 1